export default __webpack_public_path__ + "static/media/couldnt-without-you.46c586e4.webp";